import React, {useEffect, useState} from 'react';
import './Shop.css';
import { Helmet } from 'react-helmet';
import config from '../../../../config';

import ProductsManager from './ProductsManager';
import Dropdown from '../../components/Dropdown/Dropdown';
import CustomSelect from '../../components/CustomSelect/CustomSelect';
import SmallCard from '../../components/SmallCard/SmallCard';
import Loading from '../../components/Loading/Loading';
import { Funnel, SortAscending } from '@phosphor-icons/react';
import CartManager from '../../components/Cart/CartManager';

const Paginator = ({ page, limit, count, filterResults }) => {
    const totalPages = Math.ceil(count / limit);
    
    const handlePageClick = (pageNumber) => {
        if (pageNumber !== page && pageNumber >= 1 && pageNumber <= totalPages) {
            filterResults(pageNumber);
        }
    }

    let pages = Array.from({ length: 5 }, (_, i) => i + 1);
    
    if (totalPages > 5) {
        if (page <= 3) {
            pages = [1, 2, 3, 4, totalPages];
        } else if (page > totalPages - 3) {
            pages = [1, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
        } else {
            pages = [1, page - 1, page, page + 1, totalPages];
        }
    } else {
        pages = Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    return (
        <div className='d-flex align-center'>
            <button 
                className="paginator-button pointer back" 
                disabled={page === 1} 
                onClick={() => handlePageClick(page - 1)}
            >
                Back
            </button>
            <div className='Paginator'>
                {pages.map((pageNumber, index) => (
                    <div 
                        key={index} 
                        className={`page ${pageNumber === page ? 'active' : ''}`} 
                        onClick={() => handlePageClick(pageNumber)}
                    >
                        {pageNumber}
                    </div>
                ))}
            </div>
            <button 
                className="paginator-button pointer next" 
                disabled={page === totalPages} 
                onClick={() => handlePageClick(page + 1)}
            >
                Next
            </button>
        </div>
    );
}

const Shop = ({props}) => {
    const [search, setSearch] = useState("");
    const [userQueries] = useState(props.userQueries);
    const [products, setProducts] = useState(props.products.containers);
    const [options, setOptions] = useState();
    const [filters, setFilters] = useState({...props.defaultFilters})
    const [sortChoice, setSort] = useState({value:"none", label: "None"});
    const [cart, setCart] = useState([])
    const [productCount, setProductCount] = useState(props.products.count);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(12);

    useEffect(() => {
        setOptions(props.options);

        window.addEventListener('storage', storageEventHandler, false);
    
        async function storageEventHandler(e) {
            CartManager.getCartItemsFull().then(rescart => {
                setCart(rescart);
            })
        }
        
        let newFilters = {...props.defaultFilters, ...filters};
        if(filters === "NA") newFilters = {};

        const sortNames = {
            "price_desc": "Price (High to Low)",
            "price_asc": "Price (Low to High)",
            "rank_desc": "Rank (High to Low)",
            "rank_asc": "Rank (Low to High)",
            "none": "None"
        }
        userQueries.search && setSearch(userQueries.search);
        userQueries.page && setPage(userQueries.page);
        userQueries.limit && setLimit(userQueries.limit);
        userQueries.sort && setSort({value: userQueries.sort, label: sortNames[userQueries.sort]});

        Object.keys(userQueries).forEach((key) => {
            if (!["search", "page", "limit", "sort"].includes(key)) {
                newFilters = {...newFilters, [key]: [...userQueries[key].split(",")]}
            }
        })

        if(props.products.containers.length > 0) {
            setProducts(props.products.containers);
            setProductCount(props.products.count);
        }
        else {
            setProducts([]);
            setProductCount(0);
        };
/*
        ProductsManager.getProducts(newFilters, userQueries.page || page, userQueries.limit || limit, userQueries.sort || sortChoice, userQueries.search || search).then((products) => {
            if(products.containers.length > 0) {
                setProducts(products.containers);
                setProductCount(products.count);
            }
            else {
                setProducts([]);
                setProductCount(0);
            };
        })
*/
        console.log('InProductsManager');
        setFilters(newFilters)
        CartManager.getCartItemsFull().then(rescart => {
            setCart(rescart);
        });
    },[]);

    function filterResults(newPage, newSort) {
        if(typeof newPage != "number") newPage = 1;
        if(!newSort) newSort = sortChoice;

        let newUrl = "/?";
        for (const [key, value] of Object.entries(filters)) {
            if (value !== props.defaultFilters[key] && value !== "" && value[0] != "all" && (key !== "limit" && key !== "page" && key !== "sort")) {
                newUrl += `${key}=${Array.isArray(value) ? value.join(",") : value}&`
            }
        }
        newUrl = newUrl.slice(0, -1);
        window.location.href= newUrl + `${(newUrl=="/" ? "?" : "&") + (search !== "" ? `search=${search}&page=${parseInt(newPage)}&limit=${limit}&sort=${newSort.value}` : `page=${parseInt(newPage)}&limit=${limit}&sort=${newSort.value}`)}`;
    }


    function setSortChoice(sort) {
        setSort(sort);
        filterResults(page, sort);
    }

    function resetFilters() {
        setFilters(props.defaultFilters)
        window.location.href=`/${(search !== "" ? `?search=${search}` : ``)}`;
    }

    const [mobileFilter, setMobileFilter] = useState(false);
    const [mobileSort, setMobileSort] = useState(false);

    return (
        <div className='Shop'>
            <Helmet>
                <meta
                    name="description"
                    content="Browse our entire product selection."
                />
                <title>Shop A Huge Range Of Shipping Containers Online / {config.brand_name_abbrev}</title>
                <link rel="canonical" href={`https://${config.domain}/`} />
            </Helmet>
            <div className="w-90 d-flex Filters row">
                <div className='flex-2'>
                    <div className="FilterBox shadow rounded w-90 desktop mt-4">
                        <h2 className='text-center w-100 no-block-start no-block-end'>Filter Results:</h2><br/>
                        <div className='w-90 d-flex space-around'>
                            <button className="Button flex-6" onClick={filterResults}>Filter</button>
                            <div className="flex-1"></div>
                            <button className="Button grayscale flex-6" onClick={resetFilters}>Reset</button>
                        </div><br /><br />
                        <div className="w-90">
                            {
                                !!options && filters != "NA" &&
                                Object.keys(options).map((option, index) => {
                                    return (
                                        <div key={index}>
                                            <b>{option.charAt(0).toUpperCase() + option.slice(1)}:</b>
                                            <CustomSelect set={setFilters} current={filters} options={options[option]} name={option}/><br/>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                    <div className="mobile">
                        <div className="TopSection align-center">
                            <div className="w-100 text-center">
                                {
                                    search ?
                                    <h2>Found {productCount} products for: {search}</h2>
                                    :
                                    <h2>Browse {productCount} products</h2>
                                }
                                <br />
                            </div>
                            <div className="d-flex justify-center w-100">
                                <div className='d-flex align-center' style={{overflowX: 'scroll'}}>
                                    <div className={`rounded FilterToggle ${mobileFilter && 'enabled'}`} onClick={()=> {setMobileFilter(!mobileFilter); setMobileSort(false)}}><Funnel size={25} color="#2271b3" />&nbsp;&nbsp;Filters</div> &nbsp;&nbsp;&nbsp;
                                    <div style={{minWidth: ["price_desc","price_asc","rank_desc","rank_asc"].includes(sortChoice.value ) ? 227 : 143, width: ["price_desc","price_asc","rank_desc","rank_asc"].includes(sortChoice.value ) ? 227 : 143}} className={`rounded FilterToggle ${mobileSort && 'enabled'}`} onClick={()=> {setMobileSort(!mobileSort); setMobileFilter(false)}}><SortAscending size={25} color="#2271b3" />&nbsp;&nbsp;Sort: {sortChoice.label}</div> &nbsp;&nbsp;&nbsp;
                                </div>
                            </div>
                        </div>
                        
                        <div className={`mobileFilterDisplay ${mobileSort && 'enabled'}`}>
                            <br /><br />
                            <div className={`FilterBox rounded w-90`}>
                                <h2 className='text-center w-100 no-block-start no-block-end'>Sort:</h2><br/><br/>
                                <div className="w-90">
                                    <div className='ShotSortOption' onClick={()=>setSortChoice({value:"price_desc", label: "Price (High to Low)"})}>Price (High to Low)</div><br />
                                    <div className='ShotSortOption' onClick={()=>setSortChoice({value:"price_asc", label: "Price (Low to High)"})}>Price (Low to High)</div><br />
                                    <div className='ShotSortOption' onClick={()=>setSortChoice({value:"rank_desc", label: "Rank (High to Low)"})}>Rank (High to Low)</div><br />
                                    <div className='ShotSortOption' onClick={()=>setSortChoice({value:"rank_asc", label: "Rank (Low to High)"})}>Rank (Low to High)</div><br />
                                    <div className='ShotSortOption' onClick={()=>setSortChoice({value:"none", label: "None"})}>None</div>
                                </div>
                            </div>
                        </div>
                        <div className={`mobileFilterDisplay ${mobileFilter && 'enabled'}`}>
                            <br /><br />
                            <div className={`FilterBox rounded w-90`}>
                                <h2 className='text-center w-100 no-block-start no-block-end'>Filter:</h2><br/><br/>
                                <div className="w-90">
                                    {
                                        !!options && filters != "NA" &&
                                        Object.keys(options).map((option, index) => {
                                            return (
                                                <div key={index}>
                                                    <b>{option.charAt(0).toUpperCase() + option.slice(1)}:</b>
                                                    <CustomSelect set={setFilters} current={filters} options={options[option]} name={option}/><br/>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                                <div className='w-90 d-flex space-around'>
                                    <button className="Button flex-6" onClick={filterResults}>Refine</button>
                                    <div className="flex-1"></div>
                                    <button className="Button flex-6" onClick={resetFilters}>Reset</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex-7">
                    <div className="w-100 text-center">
                        <div className="w-100 text-center desktop">
                            {
                                search ?
                                <h1 className='h2-style'>Product search for: {search}</h1>
                                :
                                <h1 className='h2-style'>Browse products</h1>
                            }
                            <p>Product count: {productCount}</p>
                            <br />
                        </div>
                        <div className="desktop w-100 d-flex space-between">
                            <div> &nbsp;</div>
                            <Dropdown noCorner title={`Sort by: ${sortChoice ? sortChoice.label : ""}`} style={{minWidth: 150, textAlign: 'center'}}>
                                <div className='ShotSortOption' onClick={()=>setSortChoice({value:"price_desc", label: "Price (High to Low)"})}>Price (High to Low)</div><br /><br />
                                <div className='ShotSortOption' onClick={()=>setSortChoice({value:"price_asc", label: "Price (Low to High)"})}>Price (Low to High)</div><br /><br />
                                <div className='ShotSortOption' onClick={()=>setSortChoice({value:"rank_desc", label: "Rank (High to Low)"})}>Rank (High to Low)</div><br /><br />
                                <div className='ShotSortOption' onClick={()=>setSortChoice({value:"rank_asc", label: "Rank (Low to High)"})}>Rank (Low to High)</div><br /><br />
                                <div className='ShotSortOption' onClick={()=>setSortChoice({value:"none", label: "None"})}>None</div>
                            </Dropdown>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </div><br /><br />
                        <div className="GridDisplay justify-center">
                        {
                            products.map((product, index) => {
                                const inCart = cart.map(a => {return a.container_id}).includes(product.container_id);

                                let priority = "auto";
                                if(index === 0) priority = "high";
                                return (
                                    <SmallCard priority={priority} cart={cart} inCart={inCart} key={index} price={product.price_inc} price_ex={product.price_ex} pid={product.container_id} location={product.container_location_name} img={`/pimgV2/${product.container_id}/${product.container_photo_id}.webp`} title={product.container_iso_description}>
                                        <h4>{product.container_number}</h4>
                                        {product.container_description}
                                    </SmallCard>
                                )
                            })
                        }
                        </div>
                        {
                            products.length < 1 &&
                            <div>
                                <h4>We couldn't find any products here. Try using a different filter.</h4><br />
                                <div className="d-flex w-100 justify-center">
                                    <a href="https://www.abcchs.com.au" style={{width: "10em"}}>
                                        <button className="Button">Home</button>
                                    </a>
                                    <div style={{width: 10}}></div>
                                    <a href="/" style={{width: "10em"}}>
                                        <button className="Button">Shop All</button>
                                    </a>
                                </div>
                            </div>
                        }
                        <br /><br />
                        <br />
                        {
                            limit < productCount &&
                            <div className='w-100 d-flex justify-center'>
                                <Paginator page={parseInt(page)} limit={limit} filterResults={filterResults} count={productCount}/>
                            </div>
                        }<br />
                        <div className="w-90 rounded shadow">
                            <br /><br />
                            <div className="w-100 text-center">
                                <h3 className='no-block-start'>Can't find what you're looking for?</h3>
                                <a href="https://www.abcchs.com.au/quote">
                                    <button className="Button">Grab a quote</button>
                                </a>
                                <br /><br />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br /><br />
        </div>
    );
};

export default Shop;